import { jwtDecode } from "jwt-decode"

/**
 * This is a temporary function to allow us to bypass the readonly setting for specific NHS Numbers. This is needed
 * to enable us to test the non-readonly mode for specific test patients in production while keeping the normal
 * readonly mode.
 *
 * env: REACT_APP_READ_ONLY=true|false
 * env: REACT_APP_BYPASS_READ_ONLY_NHS_NUMBERS=number_1,number_2
 *
 * @param token
 * @returns
 */
export const readonlyMode = (token?: string): boolean => {
  if (process.env.REACT_APP_READ_ONLY !== "true") {
    return false
  }
  if (token) {
    try {
      const nhs_number = jwtDecode<{ nhs_number?: string | number }>(token).nhs_number
      if (nhs_number && process.env.REACT_APP_BYPASS_READ_ONLY_NHS_NUMBERS?.split(",")?.includes(String(nhs_number))) {
        return false
      }
    } catch {
      // unable to decode JWT, do nothing
      return true
    }
  }
  return true
}
